import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Textarea } from "components/Form/components/Textarea/Textarea";

export const TextareaFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
    inputRef,
}: FormComponentProps) => {
    return (
        <Input
            fieldProps={fieldProps}
            fieldAttr={fieldAttr}
            input={input}
            meta={meta}
            className={fieldProps?.className}
        >
            <Textarea
                attributes={fieldAttr}
                name={input.name}
                placeholder={fieldAttr?.placeholder}
                inputProps={{ ...input, onBlur: fieldProps?.onBlur ?? input.onBlur }}
                inputRef={inputRef}
            ></Textarea>
        </Input>
    );
};
